import { ArrowDownTrayIcon, CheckIcon } from "@heroicons/react/20/solid";
import Imarika1 from "../../assets/Imarika1.png"

import {
  Square3Stack3DIcon,
  UserCircleIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/solid";
import React from "react";

export default function ImarikaInvPlanTab1() {
  return (
    <div className="text-ternary-dark dark:text-ternary-light  ">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
          
            <p className="mt-6 text-base leading-7 ">
            Superior returns: Imarika ensures that you earn competitive returns on your investment as the underlying fund is structured and managed to offer competitive returns of 8 - 12% per annum. In case of poor market performance, the product has a minimum guaranteed return of 5% per annum on maturity.
            </p>
            <p className="mt-6 text-base leading-7 ">
            Affordable: Imarika allows you to contribute a minimum of only Kes 1,000 per month you can also choose to do lumpsum contributions from Kes 50,000.
            </p>
            <p className="mt-6 text-base leading-7 ">
            Free Life Insurance: Imarika provides you with Free Life Insurance cover of Kes 50,000
            </p>
            <p className="mt-6 text-base leading-7 ">
            Optional Partial Withdrawals: As the fund accumulates, you can make partial withdrawals anytime after three years at no charge.            </p>
            <p className="mt-6 text-base leading-7 ">
            Short term: Imarika investment plan is available from a term of 5 to 20 years. However, you can access your funds partially or in full from month 37 at no charge.            </p>
            <p className="mt-6 text-base leading-7 ">
            No withholding tax: Being a unit linked policy; your interest is not subjected to withholding tax. This means that you save 15% tax on the interest. Further, you can also apply for tax relief if the policy is 10 years or more.            
            </p>
            <p className="mt-6 text-base leading-7 ">
            Flexible contributions: you have the option to increase or reduce your contributions at any time with no penalties, giving you the opportunity to control how you get to your final goal.            </p>
            <div className="mt-10 flex items-center gap-x-4">
     
            </div>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
            <img src={Imarika1} className="rounded-2xl  pt-40 "/>
             
             
          
          </div>
        </div>
      </div>
    </div>
  );
}
